export default "__VITE_ASSET__0109f291__"